import React from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'

import CheckIcon from '@assets/images/icons/check.svg'
import { CancelButton, ButtonIconSquare } from '@/modules/base/components/buttons'

const CustomerLimitReachedView = (props) => {
  const { title, description, onContinue, onAbort } = props
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <span className={classes.title}>{title}</span>
      </div>
      <div className={classes.content}>
        <div className={classes.description} dangerouslySetInnerHTML={{ __html: description }}>
        </div>
      </div>
      <div className={classes.actions}>
        <CancelButton
          label={lang.cancelButtonLabel}
          customClass={classes.backButton}
          onClick={onAbort} />
        <ButtonIconSquare
          icon={CheckIcon}
          label={lang.continueButtonLabel}
          customClass={classes.continueButton}
          onClick={onContinue} />
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.headerColor,
    width: '100%',
    height: 85,
  },
  title: {
    fontSize: 24,
    color: '#fff',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 0px',
  },
  description: {
    width: 450,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '0px 40px',
  },
  backButton: {
    color: '#575d6b',
  },
  continueButton: {
    marginLeft: 15,
  },
}))

export default CustomerLimitReachedView
